import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { NeedFromAbby } from './NeedFromAbby';
import type { FaqItem } from '../types/content';
type FaqListProps = {
  items: FaqItem[];
};
export function FaqList({
  items
}: FaqListProps) {
  const [open, setOpen] = useState<number | null>(0);
  return <ul className="border-t border-stone" data-id="element-147" data-mp="1x32am4o2kf9f">
      {items.map((item, i) => {
      const isOpen = open === i;
      const id = `faq-${i}`;
      return <li key={item.question} className="border-b border-stone" data-id="element-148" data-mp="1sare7bsjfblm" data-mpi={i}>
            <h3 data-id="element-149" data-mp="1ncg4r265n33x">
              <button type="button" aria-expanded={isOpen} aria-controls={`${id}-panel`} id={`${id}-btn`} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-6 py-6 text-left" data-id="element-150" data-mp="1ne0xqnctmdzo">
                <span className="text-[clamp(1.1rem,1rem+0.35vw,1.45rem)] font-normal text-charcoal" data-id="element-151" data-mp="19fu6vr6ahe9i">{item.question}</span>
                <PlusIcon aria-hidden="true" strokeWidth={1.25} className={`h-5 w-5 shrink-0 text-charcoal transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} data-id="element-152" data-mp="1czpbbmo5q5jp" />
              </button>
            </h3>
            <AnimatePresence initial={false} data-id="element-153" data-mp="1qzqitkyxgb85">
              {isOpen && <motion.div id={`${id}-panel`} role="region" aria-labelledby={`${id}-btn`} initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.22,
            ease: [0.23, 1, 0.32, 1]
          }} className="overflow-hidden" data-id="element-154" data-mp="1qxnj297z33q8">
                  <div className="max-w-[70ch] pb-7 text-graphite" data-id="element-155" data-mp="alqmejzaj3pn">
                    <p data-id="element-156" data-mp="2d85pgwmpnq2g">{item.answer}</p>
                    {item.need && <NeedFromAbby className="mt-4" data-id="element-157" data-mp="2d7m9vmkj9drl">{item.need}</NeedFromAbby>}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </li>;
    })}
    </ul>;
}